<template>
	<div class="box" lang="zh">
		<h3>Ix cam云存储自动续费服务协议</h3>
		<div class="vhtml" v-html="htmlText" ></div>
	</div>
</template>

<script>
	import zh from '../assets/js/zh.js'
	export default {
		data() {
			return {
				htmlText: zh,
			}
		},
	}
</script>

<style lang="less" scoped>
	*{
		margin-bottom: 40px;
	}
	h3 {
		text-align: center;
	}
	.box {
		padding: 0px 20px 30px !important;
		margin-top: 50px;
		background: #FFF;
		color: #000;
		font-size: 16px;
	}
	.vhtml /deep/ p {
		margin-bottom: 20px;
		color: #333;
	}
	.vhtml /deep/ .subTitle {
		color: #000;
		font-weight: bold;
	}
</style>